"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PopoverMenu;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _Popover = _interopRequireDefault(require("./Popover"));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    iconContainer: {
      height: '48px',
      borderRadius: '16px',
      padding: theme.spacing(1.5, 2)
    },
    icon: {
      width: '32px',
      height: '32px'
    },
    chevronDown: {
      marginLeft: '8px',
      fill: theme.palette.TwClrIcn
    }
  };
});
function PopoverMenu(_ref) {
  var anchor = _ref.anchor,
    menuSections = _ref.menuSections,
    onClick = _ref.onClick;
  var classes = useStyles();
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var onItemClick = function onItemClick(selectedItem) {
    if (onClick) {
      onClick(selectedItem);
    }
    handleClose();
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: handleClick,
    size: "small",
    className: classes.iconContainer
  }, anchor, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "chevronDown",
    size: "medium",
    className: classes.chevronDown
  })), /*#__PURE__*/_react.default.createElement(_Popover.default, {
    sections: menuSections,
    handleClick: onItemClick,
    anchorElement: anchorEl,
    setAnchorElement: setAnchorEl
  }));
}